import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import PortalHeader from "../PortalHeader/PortalHeader";
import { PassengerAPI } from "../../../API/PassengerAPIs/PassengerAPIs";
import ColouredLoadingSymbol from "../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol";
import ApiResponseHandler from "../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../STCLibrary/NotificationSystem/NotificationContext";
import { AccountContext } from "../../Pages/PageRoutes/PageRoutes";

function PrivateRoutes({isParent, setIsParent, setVerified}) {

    const {accountDetails, setAccountDetails} = useContext(AccountContext); 
    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [failedToLoad, setFailedToLoad] = useState(false);
    const getUserDetails = () => {
        setLoading(true);
        setFailedToLoad(false);
        PassengerAPI.GetPortalAccount(routeParams.userID)
        .then((response) => {
            if(response.status === 200){
                setAccountDetails(response.data);
                if(response.data === ""){
                    setIsParent(false);
                    setLoading(false);
                }
                else{
                    setIsParent(true);
                    setVerified(response.data.verified)
                    setLoading(false);
                }
            }
        })
        .catch((err) => {
            console.log(err);
            setFailedToLoad(true);
            ApiResponseHandler(err.response, notificationCtx, navigate)
        })
    }

    useEffect(() => {

        // const s1 = document.createElement('script');
        // const s0 = document.getElementsByTagName('script')[0];
        // s1.async=true;
        // s1.src='https://embed.tawk.to/6572e8b170c9f2407f7d6dcd/1hh4dptnn';
        // // s1.charset='UTF-8';
        // s1.setAttribute('crossorigin','*');
        // s0.parentNode.insertBefore(s1,s0);
        // s1.id = 'chatbotChild';
        // s0.id = 'chatbotParent';
        // document.body.appendChild(s1);
        // document.body.appendChild(s0);

        getUserDetails();
    },[])

    return (
        <>
            <PortalHeader isParent={isParent}/>
            {loading ? 
            <div style={{marginTop: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {failedToLoad ? <h1>Failed to load. Please try again later.</h1> : <ColouredLoadingSymbol/>}
            </div>
            :
            <Outlet/>
            }
        </>
    )
}
export default PrivateRoutes;